var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-list-item', {
    attrs: {
      "to": "/masterorb/".concat(_vm.id)
    }
  }, [_vm.collection ? [_c('v-list-item-avatar', {
    attrs: {
      "size": 48
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.orbicon.format(_vm.id) + '.jpg'
    }
  })], 1), _c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.orb.m_Name))]), _vm.orb.m_TitleType != -1 && _vm.$i18n.locale != 'ja' ? _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$name(_vm.$store.state.$db.TitleList[_vm.orb.m_TitleType].m_DisplayName)))]) : _vm._e(), _vm.orb.m_Class != -1 && _vm.$i18n.locale != 'ja' ? _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t("Classes.".concat(_vm.orb.m_Class))))]) : _vm._e()], 1)] : [_c('v-list-item-avatar', {
    staticClass: "mx-auto mr-2 mr-md-4",
    attrs: {
      "width": _vm.$size(),
      "height": _vm.$size()
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.$asset.orbicon.format(_vm.id) + '.jpg'
    }
  })], 1), _c('v-list-item-content', {
    staticClass: "ml-0 mr-auto",
    staticStyle: {
      "max-width": "384px"
    }
  }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.orb.m_Name))]), _vm.orb.m_TitleType != -1 && _vm.$i18n.locale != 'ja' ? _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$name(_vm.$store.state.$db.TitleList[_vm.orb.m_TitleType].m_DisplayName)))]) : _vm._e(), _vm.orb.m_Class != -1 && _vm.$i18n.locale != 'ja' ? _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.$t("Classes.".concat(_vm.orb.m_Class))))]) : _vm._e()], 1)]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }